module.exports = __webpack_public_path__ + "static/media/authMain.d73a631c.png";